import React from "react";

const PlayBadgeIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      className="badge_video--24rvJ"
    >
      <g fill="none">
        <circle cx="17" cy="17" r="17" fill="#FFF" opacity="0.8"></circle>
        <path
          fill="#000"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 1.999c0-1.104.756-1.518 1.695-.92l7.61 4.846c.936.596.939 1.557 0 2.15l-7.61 4.806c-.936.591-1.695.176-1.695-.929V2z"
          transform="translate(10 10)"
        ></path>
      </g>
    </svg>
  );
};

export default PlayBadgeIcon;
